import { render, staticRenderFns } from "./clientModule.vue?vue&type=template&id=6840ac05&scoped=true"
import script from "./clientModule.vue?vue&type=script&lang=js"
export * from "./clientModule.vue?vue&type=script&lang=js"
import style0 from "./clientModule.vue?vue&type=style&index=0&id=6840ac05&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6840ac05",
  null
  
)

export default component.exports